import { ContractAddress, contractAddresses } from 'constants/address'
import { NetworkName } from 'constants/network'
import { makeAutoObservable } from 'mobx'

class ContractStore {
  addresses: ContractAddress

  constructor() {
    this.addresses = contractAddresses.mainnet
    makeAutoObservable(this)
  }

  initContractStore = (network: string) => {
    this.addresses = contractAddresses[network as NetworkName]
  }
}

export const contractStore = new ContractStore()
